import React, { useState } from "react";
import { ReactComponent as DownArrow } from "../../assets/settingPage/arrow-down.svg";
import { ReactComponent as DownArrowDark } from "../../assets/settingPage/arrow-down-dark.svg";
import { ReactComponent as DeleteIcon } from "../../assets/InvitationSystem/DeleteIcon.svg";

import OgImage from "../../assets/landingPages/homePage/Hero.png";
import HeroEllipseGroup from "../../assets/landingPages/aboutHeroEllipsGroup.png";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import useLocales from "../../hooks/useLocales";
import { Helmet } from "react-helmet";
import { FaTimes } from "react-icons/fa";
import httpFormRequest from "../../axios/form_index";
import { useSelector } from "react-redux";
import ReportAbuseConfirm from "../../components/dashboard/modal/ReportAbuseConfirm";

const inputClasses =
  "dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary border text-heading_color text-small2 md:text-body_copy2 rounded-md focus:outline-none block w-full p-[13px] py-[5px] px-[15px] md:p-[15px] md:py-[7px]";
const inputErrorClasses =
  "border-state_color_error placeholder:text-state_color_error";
const inputNoErrorClasses =
  "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color dark:border-color_dark focus:dark:border-font_color";

const ReportAbusePage = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const [file, setFile] = useState(null);
  const [selectReportTypeDropDown, setSelectReportTypeDropDown] =
    useState(false);
  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [selectedReporterType, setSelectedReporterType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { translate, currentLang } = useLocales();

  const reportTypeOptions = [
    { value: 1, label: translate("report.spam_scam_phishing") },
    { value: 2, label: translate("report.adult_content") },
    { value: 3, label: translate("report.illegal_goods_services") },
    { value: 4, label: translate("report.fraud") },
    { value: 5, label: translate("report.child_abuse") },
    { value: 6, label: translate("report.shocking_violent_content") },
    { value: 7, label: translate("report.privacy_impersonation_harassment") },
    { value: 8, label: translate("report.gambling") },
  ];

  const reporterTypeOptions = [
    { value: 1, label: translate("report.bil_bio_user") },
    { value: 2, label: translate("report.non_bil_bio_user") },
    { value: 3, label: translate("report.legal_representative") },
    { value: 4, label: translate("report.law_enforcement") },
    { value: 5, label: translate("report.regulatory_body") },
  ];

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const SubmitHandler = async (data) => {
    try {
      const url = "/api/user/saveAbuseReport";

      const bodyFormData = new FormData();
      bodyFormData.append("first_name", data?.first_name);
      bodyFormData.append("last_name", data?.last_name);
      bodyFormData.append("email", data?.email);
      bodyFormData.append("page_url", data?.page_url);
      bodyFormData.append("report_type", selectedReportType);
      bodyFormData.append("reporter_type", selectedReporterType);
      bodyFormData.append("additional_comments", data?.additional_comments);
      bodyFormData.append("doc_file", data?.doc_file);

      const response = await httpFormRequest.post(url, bodyFormData);
      const result = response?.data?.message;
      const status = response?.data?.status;

      if (status === "success") {
        setIsModalOpen(true);
        // toast.success(result);
      }
      reset();
      setValue("report_type", null);
      setValue("reporter_type", null);
      setValue("doc_file", null);
      setSelectedReportType(null);
      setSelectedReporterType(null);
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  const docFile = watch("doc_file");

  const fileChangeHandler = (e) => {
    const selectedFile = e.target.files?.[0];

    if (selectedFile && selectedFile.size > 375000) {
      toast.error(`${translate("image_smaller_than_3MB")}`);
    } else {
      if (selectedFile) {
        setValue("doc_file", selectedFile);
      }
    }
  };

  const handleRemoveImage = () => {
    setValue("doc_file", null);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Report Abuse | Bil.Bio</title>
        <meta property="og:title" content="Report Abuse | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={currentLang?.value} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <section className="-mt-[93px]  bg-[#fbf7f7] pt-[93px]">
        <img
          className="absolute top-0 left-0 h-[15rem] lg:h-[30rem]"
          src={HeroEllipseGroup}
          alt=""
        />
        <div className="flex justify-center dark:bg-dark-primary">
          <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
            <div className="relative px-6 smm:px-8 xsmfold:pt-12 pt-28 py-12">
              <div className="flex justify-center items-center xsmfold:mb-7 mb-16 2xl:mb-20">
                <div
                  className={`bg-white dark:bg-dark-secondary ${
                    darkMode ? "" : "shadow-gray-200 shadow-lg"
                  } p-5 xsmfold:p-3 w-full rounded-3xl flex flex-col lg:flex-row gap-10 sm:gap-6`}
                >
                  <div className="w-full p-1 lg:p-6">
                    <form
                      onSubmit={handleSubmit((data) => SubmitHandler(data))}
                    >
                      <div>
                        <h6 className="text-sm dark:text-color_v1_dark font-black  leading-[27px] tracking-[-0.5px] sm:leading-[31px] sm:text-custom_h6 not-italic">
                          {/* Report Abuse*/}
                          {translate("report.report_abuse")}
                        </h6>
                        <p
                          className="text-xs sm:text-base font-normal tracking-[-0.20000000298023224px] sm:tracking-[-0.30000001192092896px] mt-1 not-italic"
                          style={{ color: darkMode ? "#D5D5D5" : "#737373" }}
                        >
                          {translate("report.report_sentence")}
                        </p>
                      </div>
                      <div
                        className="border-1 border-solid mt-4"
                        style={{ borderColor: darkMode ? "#323232" : "" }}
                      />

                      <div className="grid gap-6 mb-6 md:grid-cols-2 mt-10">
                        <div>
                          <label
                            htmlFor="first_name"
                            className="block ms-[15px] mb-2 text-small2 sm:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                          >
                            {/* First name */}
                            {translate("firstName")}
                          </label>
                          <input
                            type="name"
                            id="first_name"
                            {...register("first_name", {
                              required: translate(
                                "descriptions.firstName_required"
                              ),
                              // pattern: {
                              //   value: /^[A-Za-z]+$/,
                              //   message: translate(
                              //     "descriptions.firstName_must_alphabets"
                              //   ),
                              // },
                            })}
                            className={`${inputClasses}  ${
                              errors?.first_name
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            }`}
                            placeholder={translate(
                              "front_end_pages.contact.enter_first_name"
                            )}
                          />
                          {errors?.first_name && (
                            <small className="text-state_color_error text-small3">
                              {errors?.first_name?.message}
                            </small>
                          )}
                        </div>
                        <div>
                          <label
                            htmlFor="last_name"
                            className="block ms-[15px] mb-2 text-heading_color text-small2 sm:text-body_copy2 dark:text-color_v1_dark"
                          >
                            {/* Last name */}
                            {translate("front_end_pages.contact.last_name")}
                          </label>
                          <input
                            type="lastName"
                            id="last_name"
                            {...register("last_name", {
                              required: translate(
                                "front_end_pages.contact.last_name_required"
                              ),
                              // pattern: {
                              //   value: /^[A-Za-z]+$/,
                              //   message: translate(
                              //     "descriptions.lastName_must_alphabets"
                              //   ),
                              // },
                            })}
                            className={`${inputClasses} ${
                              errors?.last_name
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            }`}
                            placeholder={translate(
                              "front_end_pages.contact.enter_last_name"
                            )}
                          />
                          {errors?.last_name && (
                            <small className="text-state_color_error text-small3">
                              {errors?.last_name?.message}
                            </small>
                          )}
                        </div>
                        <div>
                          <label
                            htmlFor="email"
                            className="block ms-[15px] mb-2 text-heading_color dark:text-color_v1_dark text-small2 sm:text-body_copy2 "
                          >
                            {/* Email */}
                            {translate("email")}&nbsp;
                            <span className="md:hidden">
                              {translate("address")}
                            </span>
                          </label>
                          <input
                            type="email"
                            id="email"
                            {...register("email", {
                              required: translate(
                                "descriptions.email_required"
                              ),
                              validate: {
                                maxLength: (v) =>
                                  v.length <= 50 ||
                                  translate(
                                    "front_end_pages.contact.the_email_should_have_less_then_characters"
                                  ),
                                matchPattern: (v) =>
                                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                    v
                                  ) || translate("descriptions.valid_email"),
                              },
                            })}
                            className={`${inputClasses} ${
                              errors?.email
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            } `}
                            placeholder={translate(
                              "front_end_pages.contact.enter_email"
                            )}
                          />
                          {errors?.email && (
                            <small className="text-state_color_error text-small3">
                              {errors?.email?.message}
                            </small>
                          )}
                        </div>

                        <div>
                          <label
                            htmlFor="page_url"
                            className="block ms-[15px] mb-2 text-small2 sm:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                          >
                            {/* Page URL that is being reported */}
                            {translate("report.page_url")}
                          </label>
                          <input
                            type="text"
                            id="page_url"
                            {...register("page_url", {
                              required: translate("report.url_required"),
                            })}
                            className={`${inputClasses} ${
                              errors?.page_url
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            }`}
                            placeholder={translate("report.enter_page_url")}
                          />
                          {errors?.page_url && (
                            <small className="text-state_color_error text-small3">
                              {errors?.page_url?.message}
                            </small>
                          )}
                        </div>

                        <div>
                          <label
                            htmlFor="report_type"
                            className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark"
                          >
                            {/* Type of report */}
                            {translate("report.report_type")}
                          </label>
                          <div className=" relative">
                            <div
                              onClick={() => {
                                setSelectReportTypeDropDown(
                                  !selectReportTypeDropDown
                                );
                              }}
                              {...register("report_type", {
                                required: translate(
                                  "report.type_report_required"
                                ),
                              })}
                              className={`bg-light_bg_v4 dark:bg-[#444444] capitalize p-[13px] pl-[10px] lg:p-[15px] text-small2 lg:text-body_copy2  dark:text-color_v2_dark rounded-md w-full flex justify-between items-center cursor-pointer ${
                                errors?.report_type
                                  ? "border border-state_color_error text-state_color_error"
                                  : "text-heading_color"
                              } `}
                            >
                              {selectedReportType
                                ? selectedReportType
                                : `${translate("report.select_report_type")}`}
                              {darkMode ? <DownArrowDark /> : <DownArrow />}
                            </div>
                            {selectReportTypeDropDown && (
                              <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-dark-secondary rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                                {reportTypeOptions.map((item, i) => {
                                  return (
                                    <div
                                      key={i}
                                      onClick={() => {
                                        setSelectedReportType(item.label);
                                        setSelectReportTypeDropDown(false);
                                        setValue("report_type", item.value);
                                        clearErrors("report_type");
                                      }}
                                      className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md dark:hover:bg-dark-primary dark:text-color_v2_dark"
                                    >
                                      {item.label}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                          {errors?.report_type && (
                            <small className="text-state_color_error text-small3">
                              {errors?.report_type.message}
                            </small>
                          )}
                        </div>

                        <div>
                          <label
                            htmlFor="reporter_type"
                            className="block mb-[1.5px] lg:mb-2 pl-[10px] lg:pl-[15px] text-small2 lg:text-body_copy2 text-heading_color "
                          >
                            {/* Reporter type */}
                            {translate("report.reporter_type")}
                          </label>
                          <div className=" relative">
                            <div
                              onClick={() => {
                                setSelectReporterTypeDropDown(
                                  !selectReporterTypeDropDown
                                );
                              }}
                              {...register("reporter_type", {
                                required: translate(
                                  "report.type_reporter_required"
                                ),
                              })}
                              className={`bg-light_bg_v4 dark:bg-[#444444] capitalize p-[13px] pl-[10px] lg:p-[15px] text-small2 lg:text-body_copy2 dark:text-color_v2_dark rounded-md w-full flex justify-between items-center cursor-pointer ${
                                errors?.reporter_type
                                  ? "border border-state_color_error text-state_color_error "
                                  : "text-heading_color "
                              }`}
                            >
                              {selectedReporterType
                                ? selectedReporterType
                                : `${translate("report.select_reporter_type")}`}
                              {darkMode ? <DownArrowDark /> : <DownArrow />}
                            </div>
                            {selectReporterTypeDropDown && (
                              <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-dark-secondary rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                                {reporterTypeOptions.map((item, i) => {
                                  return (
                                    <div
                                      key={i}
                                      onClick={() => {
                                        setSelectedReporterType(item.label);
                                        setSelectReporterTypeDropDown(false);
                                        setValue("reporter_type", item.value);
                                        clearErrors("reporter_type");
                                      }}
                                      className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md  dark:hover:bg-dark-primary dark:text-color_v2_dark"
                                    >
                                      {item.label}
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                          {errors?.reporter_type && (
                            <small className="text-state_color_error text-small3">
                              {errors?.reporter_type.message}
                            </small>
                          )}
                        </div>

                        <div>
                          <label
                            htmlFor="additional_comments"
                            className="block ms-[15px] mb-2 text-heading_color dark:text-color_v1_dark text-small2 sm:text-body_copy2 "
                          >
                            {/* additional_comments */}
                            {translate("report.additional_comment")}
                          </label>
                          <div className="relative">
                            <textarea
                              rows={"4"}
                              {...register("additional_comments", {
                                required: translate("report.comment_required"),
                              })}
                              className={`border text-heading_color text-small2 md:text-body_copy2 rounded-md resize-none focus:outline-none block w-full p-[13px] px-[15px] md:p-[15px] dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark dark:bg-dark-secondary ${
                                errors?.additional_comments
                                  ? inputErrorClasses
                                  : inputNoErrorClasses
                              }`}
                              placeholder={translate(
                                "front_end_pages.contact.enter_message_here"
                              )}
                            ></textarea>
                          </div>
                          {errors?.additional_comments && (
                            <small className="text-state_color_error text-small3">
                              {errors?.additional_comments?.message}
                            </small>
                          )}
                        </div>

                        <div>
                          <label htmlFor="doc_file">
                            <div className="block ms-[15px] mb-2 text-small2 sm:text-body_copy2 text-heading_color dark:text-color_v1_dark">
                              {/* Attachment */}
                              {translate("report.attachment")}
                            </div>
                            <div
                              className={`dark:text-font_light_color dark:bg-dark-secondary rounded-md border-dashed border-1 cursor-pointer  relative p-[15px] mt-[7px] h-[134px] w-full ${
                                errors?.doc_file
                                  ? "border border-state_color_error text-state_color_error"
                                  : "text-heading_color dark:border-color_dark focus:dark:border-font_color"
                              }`}
                            >
                              <p className="text-sm	sm:text-lg not-italic tracking-[-0.2px] sm:tracking-[-0.5px] font-normal">
                                {translate("report.attachment_paragraph")}
                              </p>
                              {docFile && docFile instanceof Blob && (
                                <div className="flex items-center mt-3">
                                  <img
                                    src={URL.createObjectURL(docFile)}
                                    className="max-w-[100px] max-h-[70px]"
                                    alt="..."
                                  />
                                  <DeleteIcon
                                    className="ml-2 cursor-pointer"
                                    onClick={handleRemoveImage}
                                  />
                                </div>
                              )}
                              <input
                                type="file"
                                id="doc_file"
                                name="doc_file"
                                onChange={(e) => {
                                  fileChangeHandler(e);
                                  clearErrors("doc_file");
                                }}
                                accept="image/*"
                                className="hidden"
                              />
                            </div>
                            {errors?.doc_file && (
                              <small className="text-state_color_error text-small3">
                                {errors?.doc_file?.message}
                              </small>
                            )}
                          </label>
                          <div
                            {...register("doc_file", {
                              required: translate("report.attachment_required"),
                            })}
                          />
                        </div>
                      </div>
                      <div
                        className="border-1 border-solid mt-6"
                        style={{ borderColor: darkMode ? "#323232" : "" }}
                      />
                      <button
                        type="submit"
                        className="bg-main_color mt-6 text-white rounded-full h-12 pt-[7px] pb-[6px] smm:pt-[10px] smm:pb-[9px] sm:pt-[13px] sm:pb-[12px] text-small3_b smm:text-small2_b sm:text-small1_bold sm:w-48 w-full"
                      >
                        {translate("submit")}
                      </button>
                      <p
                        className="font-normal mt-4 text-xs sm:text-sm tracking-[-0.2px] not-italic"
                        style={{ color: darkMode ? "#D5D5D5" : "#737373" }}
                      >
                        {translate("report.site_protected")}
                        <span className="font-bold text-main_color text-xs sm:text-sm tracking-[-0.2px] mx-1 not-italic">
                          {translate("privacy_policy")}
                        </span>
                        {translate("add")}
                        <span className="font-bold text-main_color text-xs sm:text-sm tracking-[-0.2px] mx-1 not-italic">
                          {translate("footer.terms_conditions")}
                        </span>
                        {translate("report.apply")}.
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ReportAbuseConfirm
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default ReportAbusePage;
